import { render, staticRenderFns } from "./CheckDetails.vue?vue&type=template&id=686e6daa&scoped=true&"
import script from "./CheckDetails.vue?vue&type=script&lang=js&"
export * from "./CheckDetails.vue?vue&type=script&lang=js&"
import style0 from "./CheckDetails.vue?vue&type=style&index=0&id=686e6daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e6daa",
  null
  
)

export default component.exports